export function buildTemplateDocsPath(
  dealId: string,
  packageId: string
): string {
  return `/templates/${dealId}/packages/${packageId}/docs`;
}
